/* Agroley header (AGRO-068): only the logo lettering replay (header logo and the page-heading lettering). The menu itself is Horizon's own, unmodified. */
(() => {
  if (window.__agroleyHeaderLoaded) return;
  window.__agroleyHeaderLoaded = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let flip = false;
  let lastRun = 0;
  const replay = (event) => {
    if (reduced.matches || !(event.target instanceof Element)) return;
    const brand = event.target.closest('.ag-brand, .ag-wm--page');
    if (!brand) return;
    const now = Date.now();
    if (now - lastRun < 1500) return;
    const wm = brand.matches('.ag-wm') ? brand : brand.querySelector('.ag-wm');
    if (!wm) return;
    lastRun = now;
    flip = !flip;
    wm.classList.remove('is-replay-a', 'is-replay-b');
    void wm.offsetWidth;
    wm.classList.add(flip ? 'is-replay-a' : 'is-replay-b');
  };
  document.addEventListener('mouseover', replay);
  document.addEventListener('focusin', replay);
})();
